var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "stlFilterGroup",
      class: { "is-open": _vm.isOpen, "is-mobile": _vm.isMobile },
    },
    [
      _c(
        "button",
        {
          staticClass: "stlFilterTrigger",
          class: { active: _vm.selectedOptions.length > 0 },
          attrs: {
            type: "button",
            "aria-expanded": _vm.isOpen ? "true" : "false",
          },
          on: {
            click: function ($event) {
              return _vm.$emit("toggle-open", _vm.group.type)
            },
          },
        },
        [
          _c("span", { staticClass: "stlFilterTriggerLabel" }, [
            _vm._v(_vm._s(_vm.groupName(_vm.group.type))),
          ]),
          _vm._v(" "),
          _vm.selectedOptions.length
            ? _c("span", { staticClass: "stlFilterTriggerCount" }, [
                _vm._v(_vm._s(_vm.selectedOptions.length)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "stlFilterTriggerIcon",
              attrs: {
                viewBox: "0 0 24 24",
                width: "18",
                height: "18",
                "aria-hidden": "true",
              },
            },
            [_c("polyline", { attrs: { points: "6 9 12 15 18 9" } })]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isOpen
        ? _c("div", { staticClass: "stlFilterDropdown" }, [
            _c(
              "div",
              { staticClass: "stlFilterDropdownScroll" },
              _vm._l(_vm.group.tags, function (tag) {
                return _c(
                  "button",
                  {
                    key: tag.id,
                    staticClass: "stlFilterOption",
                    class: _vm.tagClasses(tag),
                    style: _vm.tagStyle(tag),
                    attrs: { type: "button", "aria-label": tag.value },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("toggle", tag.id)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "stlFilterOptionMain" }, [
                      _vm.tagColor(tag)
                        ? _c("span", { staticClass: "stlFilterColorBadge" })
                        : _c("span", { staticClass: "stlFilterOptionLabel" }, [
                            _vm._v(_vm._s(tag.value)),
                          ]),
                      _vm._v(" "),
                      _vm.tagColor(tag)
                        ? _c("span", { staticClass: "stlFilterOptionLabel" }, [
                            _vm._v(_vm._s(tag.value)),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.isSelected(tag.id)
                      ? _c(
                          "span",
                          {
                            staticClass: "stlFilterOptionCheck",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("✓")]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }